import {ButtonProps, Typography, Button} from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { theme } from "../../../utils/theme/theme";

interface IHeaderButtonProps extends Omit<ButtonProps, "component" | "href"> {
  title: string;
  icon: React.ReactNode;
  to: string;
}

export const HeaderButton = (props: IHeaderButtonProps) => {
  const { title, icon, to } = props;
  return (
    <Button
        component={Link}
        to={to}
        disableRipple
        startIcon={icon}
          sx={{
            color: theme.palette.secondary.main,
              ":visited":{color: theme.palette.secondary.main },
            ":hover": { color: "black" },
            svg: { marginTop: "-1px" },
          }}
    >
        <Typography>{title}</Typography>
    </Button>
  );
};
